// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "7.101.0/js/resources/" + chunkId + ".js";
};